<div class="ba-spacing-bottom-h3">
    <pf-hinweisbox
            [boxType]="hinweisboxType.WARNING"
            boxId="kpf-warn-eingeschraenkt-nutzbar"
            boxTitle="{{ titleKey | i18next }}"
            headerSize="h2"
    >
        <div id="hinweistext-kdnr-error-meldung">
            <p>{{ firstInfoKey | i18next }}</p>
            <p class="ba-copytext" [innerHTML]="secondInfoKey | i18next:{link: getLinkHtml}"></p>
        </div>
    </pf-hinweisbox>
</div>
